import { render } from "./RoleDetail.vue?vue&type=template&id=360f2541&scoped=true"
import script from "./RoleDetail.vue?vue&type=script&lang=js"
export * from "./RoleDetail.vue?vue&type=script&lang=js"

import "./RoleDetail.vue?vue&type=style&index=0&id=360f2541&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360f2541"],['__file',"src/views/qywx/common/sys/RoleDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "360f2541"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('360f2541', __exports__)) {
    api.reload('360f2541', __exports__)
  }
  
  module.hot.accept("./RoleDetail.vue?vue&type=template&id=360f2541&scoped=true", () => {
    api.rerender('360f2541', render)
  })

}


export default __exports__